module.exports = __webpack_public_path__ + "static/fonts/SCDream8.4510268.woff";